import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "@/lib/auth";
import { toast } from "sonner";

export default function AdminLogin() {
  const { login } = useAuth();
  const nav = useNavigate();
  const [role, setRole] = useState("admin");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [err, setErr] = useState("");
  const [busy, setBusy] = useState(false);

  const setRoleTab = (r) => {
    setRole(r);
    setErr("");
  };

  const submit = async (e) => {
    e.preventDefault(); setErr(""); setBusy(true);
    try {
      const u = await login(email.trim().toLowerCase(), password);
      if (u.role === "client") { setErr("This is the admin console. Use the client portal."); return; }
      toast.success("Signed in");
      nav("/admin");
    } catch (e2) {
      const d = e2?.response?.data?.detail;
      let msg = "Incorrect email or password.";
      if (typeof d === "string") msg = d;
      else if (Array.isArray(d) && d[0]?.msg) msg = d[0].msg;
      else if (e2?.message && !e2?.response) msg = `Network error: ${e2.message}`;
      console.error("Admin login failed:", e2);
      setErr(msg);
    } finally { setBusy(false); }
  };

  return (
    <div className="min-h-screen grid md:grid-cols-[1fr_480px]" data-testid="admin-login-root">
      <div className="p-12 hidden md:flex flex-col justify-between" style={{ background: "var(--ink)", color: "var(--cream-2)" }}>
        <Link to="/" className="text-2xl font-display font-black">Ask<span style={{ color: "var(--kiwi-2)" }}>Tax</span> <span className="text-xs font-normal opacity-60 uppercase tracking-widest ml-2">Admin</span></Link>
        <div>
          <span className="eyebrow light">Answer desk</span>
          <h1 className="h1-display mt-4" style={{ fontSize: 56 }}>
            One question.<br /><span className="font-serif-i font-normal" style={{ textTransform: "none", color: "var(--kiwi-2)" }}>One clear answer.</span>
          </h1>
          <p className="mt-6 font-serif text-lg" style={{ color: "var(--cream-3)" }}>
            Review drafted answers, approve, and deliver — one paid question at a time.
          </p>
        </div>
        <div className="text-xs" style={{ color: "var(--muted-2)" }}>IRD-registered New Zealand tax agent · Admin console</div>
      </div>
      <div className="p-8 md:p-12 flex items-center justify-center" style={{ background: "var(--cream)" }}>
        <form onSubmit={submit} className="at-card p-8 w-full max-w-md">
          <div className="text-2xl font-display font-black uppercase">Sign in</div>
          <div className="mt-1 font-serif italic" style={{ color: "var(--muted)" }}>Welcome back to the answer desk.</div>
          {err && <div className="mt-4 p-3 border-2 text-sm font-display font-bold uppercase tracking-wide" style={{ borderColor: "var(--clay)", background: "#f4e0d8", color: "var(--clay)" }} data-testid="admin-login-error">{err}</div>}
          <div className="mt-4 vtoggle">
            <button type="button" onClick={() => setRoleTab("admin")} className={`vt-btn ${role === "admin" ? "on" : ""}`} data-testid="role-admin">Admin</button>
            <button type="button" onClick={() => setRoleTab("super")} className={`vt-btn ${role === "super" ? "on" : ""}`} data-testid="role-super">Super Admin</button>
          </div>
          <div className="mt-4">
            <label className="at-label">Email</label>
            <input className="at-input" type="email" value={email} onChange={e => setEmail(e.target.value)} data-testid="admin-login-email" />
          </div>
          <div className="mt-4">
            <label className="at-label">Password</label>
            <input className="at-input" type="password" value={password} onChange={e => setPassword(e.target.value)} data-testid="admin-login-password" />
          </div>
          <button disabled={busy} className="at-btn block mt-6" data-testid="admin-login-submit">{busy ? "Signing in…" : "Sign in"}</button>
          <div className="mt-4 text-sm text-center">
            <Link to="/forgot-password" className="font-bold" style={{ color: "var(--kiwi)" }} data-testid="admin-forgot-password-link">Forgot password?</Link>
          </div>
        </form>
      </div>
    </div>
  );
}
